export function triggerCharacter(char, {
  allowSpaces = false,
  minLength = 0
}) {
  return ($position, editorView) => {
    if ($position.depth === 0) {
      return null;
    }

    // Allow Regex special characters to be used as triggers.
    let escapedChar = ['\\', '$'].includes(char) ? `\\${char}` : char;
    // Matching expressions used for later
    let suffix = new RegExp(`\\s${escapedChar}$`);
    let regexp = allowSpaces ? new RegExp(`${escapedChar}.*?(?=\\s${escapedChar}|$)`, 'g') : new RegExp(`${escapedChar}[^\\s${escapedChar}]*`, 'g');

    // Lookup the boundaries of the current node from the start of the node to the
    // current cursor position
    let textFrom = $position.before();
    let textTo = $position.pos;
    let text = $position.doc.textBetween(textFrom, textTo, '\0', '\0');
    let match;
    while (match = regexp.exec(text)) {
      // Javascript doesn't have lookbehinds; this hacks a check that first character is " " or the line beginning
      let prefix = match.input.slice(Math.max(0, match.index - 1), match.index);
      if (/^[\s\0]?$/.test(prefix)) {
        // The absolute position of the match in the document
        let from = match.index + $position.start();
        let to = from + match[0].length;

        // The coordinates from the matching char to the current position
        let offsetFrom = editorView.coordsAtPos(match.index);
        let offsetTo = editorView.coordsAtPos(to);
        let matchLength = to - from;
        if (matchLength >= minLength + char.length) {
          // Edge case handling; if spaces are allowed and we're directly in between two triggers
          if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
            match[0] += ' ';
            to++;
          }

          // If the $position is located within the matched substring, return that range
          if (from < $position.pos && to >= $position.pos) {
            return {
              range: {
                from,
                to
              },
              text: match[0],
              offset: {
                from: offsetFrom,
                to: offsetTo
              }
            };
          }
        }
      }
    }
    return null;
  };
}